import { MenuItem } from "@/src/types/components";
import { BookImage, BookKey, BotMessageSquare, Cable, ChartSpline, CheckSquare, ClipboardClock, Columns, Contact, CreditCard, Database, FileImage, Form, GitBranch, HatGlasses, Image, Import, Kanban, LayoutDashboard, LayoutTemplate, ListOrdered, MailCheck, Megaphone, Menu, MessageCircle, MessageSquare, MessageSquareText, Navigation, Phone, PhoneCall, PlayCircle, Plug, Receipt, Settings, ShieldUser, SquareKanban, Tags, Timer, Users, Webhook, Workflow, Wrench, Zap } from "lucide-react";
import { ROUTES } from "../constants";

export const MENUITEMS: MenuItem[] = [
  {
    icon: <LayoutDashboard size={20} />,
    label: "dashboard",
    path: ROUTES.Dashboard,
    order: 1,
    permission: "view.dashboard",
  },
  {
    icon: <MessageCircle size={20} />,
    label: "chat",
    path: ROUTES.WAChat,
    order: 2,
    permission: "manage.conversations",
  },
  {
    icon: <Image size={20} />,
    label: "chat_theme",
    path: ROUTES.ChatTheme,
    order: 3,
    permission: "manage.conversations",
  },
  {
    icon: <SquareKanban size={20} />,
    label: "pipeline_board",
    path: ROUTES.PipelineBoard,
    order: 3,
    permission: "view.kanban_funnel",
  },
  {
    icon: <Plug size={20} />,
    label: "connect_waba",
    path: ROUTES.WABAConnection,
    section: "integrations_sidebar_title",
    order: 4,
    permission: "view.waba_configuration",
  },
  {
    icon: <Phone size={20} />,
    label: "waba_phone_numbers",
    path: ROUTES.WABAPhoneNumbers,
    section: "integrations_sidebar_title",
    order: 5,
    permission: "view.waba_configuration",
  },
  {
    icon: <ShieldUser size={20} />,
    label: "google_account",
    path: ROUTES.GoogleAccount,
    section: "integrations_sidebar_title",
    order: 6,
    permission: "view.google_account",
  },
  {
    icon: <LayoutTemplate size={20} />,
    label: "templates",
    path: ROUTES.MessageTemplates,
    section: "integrations_sidebar_title",
    order: 6,
    permission: "view.template",
  },
  {
    icon: <Wrench size={20} />,
    label: "tools",
    path: ROUTES.Tools,
    section: "integrations_sidebar_title",
    order: 6,
    permission: "view.short_links",
  },
  {
    icon: <Tags size={20} />,
    label: "tags",
    path: ROUTES.Tags,
    section: "integrations_sidebar_title",
    order: 6,
    permission: "view.tags",
  },
  {
    icon: <MessageSquareText size={20} />,
    label: "quick_replies",
    path: ROUTES.QuickReplies,
    section: "integrations_sidebar_title",
    order: 7,
    permission: "view.quick_replies",
  },
  {
    icon: <Image size={20} />,
    label: "media",
    path: ROUTES.Media,
    section: "integrations_sidebar_title",
    order: 8,
    permission: "view.attachment",
  },
  {
    icon: <Users size={20} />,
    label: "teams",
    path: ROUTES.Teams,
    section: "integrations_sidebar_title",
    order: 8,
    permission: "view.teams",
  },
  {
    icon: <HatGlasses size={20} />,
    label: "agent",
    path: ROUTES.Agents,
    section: "integrations_sidebar_title",
    order: 8,
    permission: "view.agents",
  },
  {
    icon: <HatGlasses size={20} />,
    label: "tasks",
    path: ROUTES.Tasks,
    section: "integrations_sidebar_title",
    order: 8,
    permission: "view.agent-task",
  },
  {
    icon: <Workflow size={20} />,
    label: "bot_flow",
    path: ROUTES.BotFlow,
    section: "auto_responses_sidebar_title",
    order: 8,
    permission: "view.automation_flows",
  },
  {
    icon: <MailCheck size={20} />,
    label: "default_action",
    path: ROUTES.DefaultAction,
    section: "auto_responses_sidebar_title",
    order: 8,
    permission: "view.message_bots",
  },
  {
    icon: <BotMessageSquare size={20} />,
    label: "reply_material",
    path: ROUTES.ReplyMaterials,
    section: "auto_responses_sidebar_title",
    order: 8,
    permission: "view.reply_materials",
  },
  {
    icon: <BookKey size={20} />,
    label: "keyword_action",
    path: ROUTES.KeywordAction,
    section: "auto_responses_sidebar_title",
    order: 8,
    permission: "view.message_bots",
  },
  {
    icon: <PhoneCall size={20} />,
    label: "ai_calling",
    path: ROUTES.AICallAgents,
    section: "auto_responses_sidebar_title",
    order: 8,
    permission: "view.whatsapp_calling",
  },
  {
    icon: <Form size={20} />,
    label: "form_builder",
    path: ROUTES.WhatsappForm,
    section: "auto_responses_sidebar_title",
    order: 8,
    permission: "view.form_builder",
  },
  {
    icon: <ClipboardClock size={20} />,
    label: "appointment_booking",
    path: ROUTES.AppointmentBooking,
    section: "auto_responses_sidebar_title",
    order: 8,
    permission: "view.appointment_booking",
  },
  {
    icon: <Receipt size={20} />,
    label: "subscription",
    path: ROUTES.BillingPlans,
    section: "my_subscription_sidebar_title",
    order: 9,
    permission: "view.subscriptions",
  },
  {
    icon: <CreditCard size={20} />,
    label: "payment_gateway",
    path: ROUTES.PaymentGateway,
    section: "my_subscription_sidebar_title",
    order: 10,
    permission: "view.payment_gateways",
  },
  {
    icon: <ListOrdered size={20} />,
    label: "payment_transactions_title",
    path: ROUTES.PaymentTransactions,
    section: "my_subscription_sidebar_title",
    order: 11,
    permission: "view.payment_gateways",
  },
  // {
  //   icon: <FileText size={20} />,
  //   label: "invoices",
  //   path: "/invoices",
  //   section: "my_subscription_sidebar_title",
  //   order: 10,
  // },
  {
    icon: <ChartSpline size={20} />,
    label: "facebook_account",
    path: ROUTES.FacebookAccount,
    section: "marketing_sidebar_title",
    order: 8,
    permission: "manage.facebook",
  },
  {
    icon: <Megaphone size={20} />,
    label: "campaign",
    path: ROUTES.MessageCampaigns,
    section: "marketing_sidebar_title",
    order: 12,
    permission: "view.campaigns",
  },
  {
    icon: <ListOrdered size={20} />,
    label: "order",
    path: ROUTES.Orders,
    section: "marketing_sidebar_title",
    order: 13,
    permission: "view.ecommerce_orders",
  },
  {
    icon: <BookImage size={20} />,
    label: "catalogue",
    path: ROUTES.Catalogues,
    section: "marketing_sidebar_title",
    order: 13,
    permission: "view.ecommerce_catalogs",
  },
  {
    icon: <Webhook size={20} />,
    label: "event_notifications",
    path: ROUTES.Webhooks,
    section: "marketing_sidebar_title",
    order: 13,
    permission: "view.ecommerce_webhooks",
  },
  {
    icon: <Contact size={20} />,
    label: "contact",
    path: ROUTES.ContactDirectory,
    order: 16,
    permission: "view.contacts",
  },
  {
    icon: <Database size={20} />,
    label: "segments",
    path: ROUTES.Segments,
    order: 16,
    permission: "view.segments",
  },
  {
    icon: <Columns size={20} />,
    label: "columns",
    path: ROUTES.Columns,
    order: 16,
    permission: "view.custom_fields",
  },
  {
    icon: <Import size={20} />,
    label: "import_job",
    path: ROUTES.ImportJobs,
    order: 16,
    permission: "view.import_jobs",
  },
  {
    icon: <Settings size={20} />,
    label: "setup",
    path: ROUTES.AIConfig,
    order: 17,
    permission: "view.user_settings",
  },
  {
    icon: <Cable size={20} />,
    label: "api_doc",
    path: ROUTES.IntegrationTools,
    order: 18,
    permission: "view.api_key",
  },
];

export const NODETEMPLATES = [
  {
    id: "trigger",
    label: "Automation Entry",
    description: "The starting point for your automation sequence",
    icon: <PlayCircle />,
    color: "var(--indigo-500)",
    category: "START",
  },
  {
    id: "text_message",
    label: "Send Message",
    description: "Transmit a simple text response to the user",
    icon: <MessageSquareText />,
    color: "var(--emerald-500)",
    category: "MESSAGING",
  },
  {
    id: "button_message",
    label: "Quick Reply",
    description: "Present the user with interactive choice buttons",
    icon: <CheckSquare />,
    color: "var(--emerald-500)",
    category: "MESSAGING",
  },
  {
    id: "list_message",
    label: "Selection List",
    description: "Provide a structured menu of selectable options",
    icon: <Menu />,
    color: "var(--violet-500)",
    category: "INTERACTIONS",
  },
  {
    id: "media_message",
    label: "Attach Media",
    description: "Send images, videos, or documents to the user",
    icon: <FileImage />,
    color: "var(--violet-500)",
    category: "INTERACTIONS",
  },
  {
    id: "location",
    label: "Send Location",
    description: "Share geographical coordinates with the user",
    icon: <Navigation />,
    color: "var(--violet-500)",
    category: "INTERACTIONS",
  },
  {
    id: "delay",
    label: "Wait Timer",
    description: "Introduce a timed pause before the next step",
    icon: <Timer />,
    color: "var(--warning-amber)",
    category: "UTILITIES",
  },
  {
    id: "condition",
    label: "Logic Control",
    description: "Create branching paths based on specific conditions",
    icon: <GitBranch />,
    color: "var(--indigo-500)",
    category: "LOGIC",
  },
  {
    id: "wait_for_reply",
    label: "Wait for Reply",
    description: "Value from user reply to a variable for later use",
    icon: <MessageSquare />,
    color: "var(--warning-amber)",
    category: "UTILITIES",
  },
  {
    id: "api",
    label: "External API",
    description: "Connect with external services via HTTP requests",
    icon: <Zap />,
    color: "var(--blue-500)",
    category: "INTEGRATIONS",
  },
  {
    id: "response_saver",
    label: "Save Response",
    description: "Map API response data to custom fields",
    icon: <Database />,
    color: "var(--pink-500)",
    category: "INTEGRATIONS",
  },
  {
    id: "send_template",
    label: "Send Template",
    description: "Transmit a pre-defined template message",
    icon: <LayoutTemplate />,
    color: "var(--emerald-500)",
    category: "MESSAGING",
  },
  {
    id: "cta_button",
    label: "Call to Action",
    description: "Send a message with a custom web link button",
    icon: <Zap />,
    color: "var(--emerald-500)",
    category: "MESSAGING",
  },
  {
    id: "assign_chatbot",
    label: "Assign Chatbot",
    description: "Hand over the conversation to an AI chatbot",
    icon: <BotMessageSquare />,
    color: "var(--violet-500)",
    category: "INTERACTIONS",
  },
  {
    id: "save_to_google_sheet",
    label: "Google Sheets",
    description: "Export data to a Google Spreadsheet",
    icon: <FileImage />,
    color: "var(--google-green)",
    category: "INTEGRATIONS",
  },
  {
    id: "create_calendar_event",
    label: "Calendar Event",
    description: "Schedule a Google Calendar event",
    icon: <Timer />,
    color: "var(--google-blue)",
    category: "INTEGRATIONS",
  },
  {
    id: "add_tag",
    label: "Assign Tag",
    description: "Assign a CRM tag to the current contact",
    icon: <Tags />,
    color: "var(--blue-500)",
    category: "CRM",
  },
];
